/* eslint-disable */
//
import React, { Component } from "react"
import PropTypes from "prop-types"

import {
    federalRegions,
    stateRegions,
    federalAndStates,
    usRegions,
    euRegions,
    regionsWithSponsors,
} from "shared/imports/regionConstants"
import { getBillYearOptions, getBillYearSelectOptions, MAX_BILL_SEARCHIFY_SELECTIONS } from "shared/search/constants"
import {
    createEnumToggleMultiFilter,
    createNumericTripletMultiFilter,
    createProfileToggleFilter,
    datePickerGenericFilter,
    enumBillGlobalStatusFilter,
    enumSingleGenericFilter,
    textGenericFilter,
    // sorting functions
    enumValueSort,
    enumOrderSort,
    enumLabelSort,
} from "shared/search/containers/Filter/Filters"

import {
    enumGenericFilter,
    searchifySelectGenericFilter,
    toggleGenericFilter,
    createSelectToggleMultiFilter,
} from "shared/search/containers/Filter/FilterCreators"

import {
    BillFilterableListView,
    CommitteeFilterableListView,
    EventFilterableListView,
    IssueSearchifyFLV,
    BulkUploadFileFLV,
    IssueManagementFilterableListView,
    OfficialsAndStaffEUFilterableListView,
    TrackingDashboardFilterableListView,
    LegislatorSearchifyWithoutCampaignFinanceFLV,
} from "shared/search/containers/FilterableListView/FilterableListViews"

import {
    IssueSelect,
    CommitteeSelect,
    EventSelect,
    BillSelect,
    IssueManagementSelect,
    BulkUploadFileSelect,
    OfficialsAndStaffSelect,
    TrackingDashboardSelect,
    LegislatorSelectWithoutCampaignFinance,
} from "app/static/frontend/selects/containers/PieSelect"

import {
    BillCommitteeTypeSelect,
    BillDateListSelect,
    BillSupportedRegionSelect,
    BillYearSelect,
    DateListSelect,
    DateListNoFutureSelect,
    DateListNoPastSelect,
    InitiativeDetailedStatusSelect,
} from "app/static/frontend/selects/containers/EnumSelect"

import {
    getBillGlobalRegionOptions,
    getBillLanguageFilterOptions,
    getBillSupportedRegionOptions,
} from "shared/selects/helperFunctions"

/** ***************************************************************************
 *
 * Filters for Bills! Probably will be moved into another file one day.
 *
 ***************************************************************************** */

export const BillLegYearNewFilter = createEnumToggleMultiFilter({
    uniqueFilterId: "billLegYearNew",
    displayLabel: "Years",
    displayKey: "display_text",
    selectComponent: BillYearSelect,
    filterKeyMapping: {
        true: "for_years",
        false: "for_introduced_years",
    },
    toggleDisplayLabel: "Carry-over",
    toggleTextMapping: {
        trueText: "Include",
        falseText: "Exclude",
    },
    enumItems: getBillYearOptions(),
    enumSelectItems: getBillYearSelectOptions(),
})

export class BillLegYearFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "billLegYear",
        filterKey: "for_years",
        // ._.
        enumItems: getBillYearOptions(),
        displayLabel: Userdata.isStatesMode() ? "Years (incl. Carryover)" : "Years",
        selectComponent: BillYearSelect,
        regions: stateRegions,
        displayKey: "display_text",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BillLegYearNoCarryoverFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "billLegYearNoCarryover",
        filterKey: "for_introduced_years",
        // ._.
        enumItems: getBillYearOptions(),
        displayLabel: "Years (excl. Carryover)",
        selectComponent: BillYearSelect,
        regions: stateRegions,
        displayKey: "display_text",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BillLegCurrentSessionFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "billLegCurrentSession",
        filterKey: "current_session",
        trueText: "Current Session",
        falseText: "All Previous",
        onlyRegions: federalRegions,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BillDateListFilter extends Component {
    static defaultProps = {
        filterComponent: enumSingleGenericFilter,
        uniqueFilterId: "billDateListFilter",
        filterKey: "introduced_date_range",
        enumItems: DjangIO.app.events.models.DateRangeType.region_supported_items().filter(
            (item) =>
                ![
                    DjangIO.app.events.models.DateRangeType.future.value,
                    DjangIO.app.events.models.DateRangeType.next_month.value,
                    DjangIO.app.events.models.DateRangeType.next_week.value,
                ].includes(item.value),
        ),
        sortBy: enumOrderSort,
        selectComponent: BillDateListSelect,
        multi: false,
        placeholder: Userdata.isOnlyEUMode() ? "Choose Date Proposed..." : "Choose Date Introduced...",
        displayLabel: Userdata.isOnlyEUMode() ? "Date Proposed" : "Date Introduced",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BillMostRecentDateListFilter extends Component {
    static defaultProps = {
        filterComponent: enumSingleGenericFilter,
        uniqueFilterId: "billMostRecentDateListFilter",
        filterKey: "most_recent_action_date_range",
        enumItems: DjangIO.app.events.models.DateRangeType.region_supported_items().filter(
            (item) =>
                ![
                    DjangIO.app.events.models.DateRangeType.future.value,
                    DjangIO.app.events.models.DateRangeType.next_month.value,
                    DjangIO.app.events.models.DateRangeType.next_week.value,
                ].includes(item.value),
        ),
        sortBy: enumOrderSort,
        selectComponent: DateListNoFutureSelect,
        multi: false,
        displayLabel: "Date of Last Timeline Action",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BillMostRecentDateAfterFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "billMostRecentDateAfterFilter",
        filterKey: "most_recent_action_date__gt",
        displayLabel: "Last Timeline Action After",
        noFuture: true,
        helpText: "Last Timeline Action Date occurred after date selected. Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BillMostRecentDateBeforeFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "billMostRecentDateBeforeFilter",
        filterKey: "most_recent_action_date__lt",
        displayLabel: "Last Timeline Action Before",
        noFuture: true,
        helpText: "Last Timeline Action Date occurred before date selected. Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BillMostRecentTextDateListFilter extends Component {
    static defaultProps = {
        filterComponent: enumSingleGenericFilter,
        uniqueFilterId: "billMostRecentTextDateListFilter",
        filterKey: "most_recent_text_date_range",
        enumItems: DjangIO.app.events.models.DateRangeType.region_supported_items().filter(
            (item) =>
                ![
                    DjangIO.app.events.models.DateRangeType.future.value,
                    DjangIO.app.events.models.DateRangeType.next_month.value,
                    DjangIO.app.events.models.DateRangeType.next_week.value,
                ].includes(item.value),
        ),
        sortBy: enumOrderSort,
        selectComponent: DateListNoFutureSelect,
        multi: false,
        displayLabel: "Date of New Text Version",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BillMostRecentTextDateAfterFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "billMostRecentTextDateAfterFilter",
        filterKey: "most_recent_text_after",
        displayLabel: "New Text Version After",
        noFuture: true,
        helpText: "Most recent text version after date selected. Excludes date selected",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BillMostRecentTextDateBeforeFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "billMostRecentTextDateBeforeFilter",
        filterKey: "most_recent_text_before",
        displayLabel: "New Text Version Before",
        noFuture: true,
        helpText: " Most recent text version before date selected. Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BillDateStatusListFilter extends Component {
    static defaultProps = {
        filterComponent: enumSingleGenericFilter,
        uniqueFilterId: "billDateStatusListFilter",
        filterKey: "status_date_range",
        enumItems: DjangIO.app.events.models.DateRangeType.region_supported_items(),
        sortBy: enumOrderSort,
        selectComponent: DateListSelect,
        displayLabel: "Detailed Status Date",
        multi: false,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BillDateAfterFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "billDateAfter",
        filterKey: "introduced_date__gt",
        displayLabel: Userdata.isOnlyEUMode() ? "Proposed After" : "Introduced After",
        noFuture: true,
        helpText: Userdata.isOnlyEUMode()
            ? "Legislation proposed after date selected. Excludes date selected."
            : "Bill introduced after date selected. Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BillDateBeforeFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "billDateBefore",
        filterKey: "introduced_date__lt",
        displayLabel: Userdata.isOnlyEUMode() ? "Proposed Before" : "Introduced Before",
        noFuture: true,
        helpText: Userdata.isOnlyEUMode()
            ? "Legislation proposed before date selected. Excludes date selected."
            : "Bill introduced before date selected. Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BillDateOfHearingListFilter extends Component {
    static defaultProps = {
        filterComponent: enumSingleGenericFilter,
        uniqueFilterId: "billDateOfHearingListFilter",
        filterKey: "event_date_range",
        enumItems: DjangIO.app.events.models.DateRangeType.region_supported_items().filter(
            (item) =>
                item.value !== DjangIO.app.events.models.DateRangeType.this_quarter.value &&
                item.value !== DjangIO.app.events.models.DateRangeType.this_year.value,
        ),
        sortBy: enumOrderSort,
        selectComponent: DateListNoPastSelect,
        displayLabel: "Date of Scheduled Hearing",
        multi: false,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BillTypeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "billTypeFilter",
        filterKey: "bill_type__in",
        enumItems: DjangIO.app.bill.models.BillType.region_supported_items(),
        enumGroups: DjangIO.app.bill.models.BillType.filter_groups.filter((group) => group.title !== "Legislation"),
        displayKey: Userdata.isStatesMode() ? "state_search_display" : "search_display",
        sortBy: enumOrderSort,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class EULegislationTypeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "euLegislationTypeFilter",
        filterKey: "bill_type__in",
        enumItems: DjangIO.app.bill.models.BillType.region_supported_items().filter((item) =>
            [
                DjangIO.app.bill.models.BillType.eu_initiative.value,
                DjangIO.app.bill.models.BillType.legislative_regulation.value,
                DjangIO.app.bill.models.BillType.legislative_directive.value,
                DjangIO.app.bill.models.BillType.legislative_decision.value,
            ].includes(item.value),
        ),
        displayKey: "search_display",
        sortBy: enumOrderSort,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BillIsAppropsBillFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "billIsAppropsBillFilter",
        filterKey: "is_approps_bill",
        trueText: "Is Approps Bill",
        falseText: "Not Approps Bill",
        displayLabel: "Appropriations Bills",
        regions: federalRegions,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BillGeneralStatusFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "billGeneralStatusFilter",
        filterKey: "current_general_status__in",
        enumItems: DjangIO.app.bill.status.GeneralBillStatus.region_supported_items(),
        enumGroups: DjangIO.app.bill.status.GeneralBillStatus.filter_groups,
        sortBy: enumValueSort,
        displayLabel: Userdata.has_international_region ? "" : "Milestones",
        shouldRenderSelectAll: false,
        helpText: Userdata.has_international_region
            ? null
            : "Choose the bills that are currently in each of our 6 major " +
              'statuses. If you choose "Passed Original Chamber", you\'ll be looking ' +
              "at all bills that have passed that chamber but have not gone further. If " +
              "you'd like to see all the bills that have at least passed the First Chamber, " +
              'select "Passed Original Chamber", "Passed Second Chamber", and all subsequent ' +
              "milestones.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BillGlobalStatusFilter extends Component {
    static defaultProps = {
        filterComponent: enumBillGlobalStatusFilter,
        uniqueFilterId: "billGlobalStatusFilter",
        filterKey: "current_general_status__in",
        enumItems: [
            DjangIO.app.bill.status.GeneralBillStatus.global_introduced,
            DjangIO.app.bill.status.GeneralBillStatus.global_in_progress,
            DjangIO.app.bill.status.GeneralBillStatus.global_adopted,
        ],
        sortBy: enumValueSort,
        shouldRenderSelectAll: false,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class InitiativeDetailedStatusFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        selectComponent: InitiativeDetailedStatusSelect,
        uniqueFilterId: "billDetailedStatusFilter",
        filterKey: "current_status__in",
        enumItems: Object.values(DjangIO.app.bill.status.BillStatus._items).filter((item) =>
            [
                DjangIO.app.bill.status.GeneralBillStatus.eu_initiative_in_preparation.value,
                DjangIO.app.bill.status.GeneralBillStatus.eu_initiative_commission_adoption.value,
            ].includes(item.general_status),
        ),
        sortBy: enumValueSort,
        displayLabel: "Detailed Initiative Stage",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BillActionAfterFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "billActionAfter",
        filterKey: "current_status_date__gt",
        displayLabel: "Detailed Status After",
        helpText: "Most recent detailed status date occurred after date selected. Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BillActionBeforeFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "billActionBefore",
        filterKey: "current_status_date__lt",
        displayLabel: "Detailed Status Before",
        helpText: "Most recent detailed status date occurred before date selected. Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BillTitleFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: textGenericFilter,
            uniqueFilterId: "billTitle",
            filterKey: "title_search",
            placeholderText: "Search text of title...",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BillTermFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "billTermFilter",
            filterKey: "for_terms",
            searchifyFLV: IssueSearchifyFLV,
            dataTypeLabel: "Issues",
            selectComponent: IssueSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BillHearingFilter extends Component {
    static get defaultProps() {
        return {
            dataTypeLabel: "Official Events",
            displayLabel: "Hearing Scheduled",
            filterComponent: searchifySelectGenericFilter,
            filterKey: "in_events",
            searchifyFLV: EventFilterableListView,
            searchifyPermanentFilter: {
                event_type: DjangIO.app.events.models.EventType.committee_meeting.value,
            },
            selectComponent: EventSelect,
            uniqueFilterId: "billHearingFilter",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BillCommitteeFilter extends Component {
    static get defaultProps() {
        return {
            dataTypeLabel: "Committees",
            displayLabel: "Committee Referral",
            filterComponent: searchifySelectGenericFilter,
            filterKey: "from_committee",
            searchifyFLV: CommitteeFilterableListView,
            selectComponent: CommitteeSelect,
            uniqueFilterId: "billCommitteeFilter",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class BillCommitteeTypeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "billCommitteeTypeFilter",
        filterKey: "committee_keywords",
        enumItems: DjangIO.app.committee.models.CommitteeKeyword.region_supported_items(),
        sortBy: enumValueSort,
        displayLabel: "Committee Type",
        regions: stateRegions,
        selectComponent: BillCommitteeTypeSelect,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const BillSponsorFilter = createSelectToggleMultiFilter({
    uniqueFilterId: "billSponsor",
    displayLabel: Userdata.has_international_region ? "Key Players" : "Sponsors",
    getSearchifyFLV: () => LegislatorSearchifyWithoutCampaignFinanceFLV,
    dataTypeLabel: "Members",
    filterKeyMapping: { true: "sponsored_by_or", false: "sponsored_by_and" },
    selectComponent: LegislatorSelectWithoutCampaignFinance,
    helpText:
        "Select individual legislators or lists of legislators to show the bills that " +
        'they have sponsored. Selecting "ANY" will show bills where any of the selected ' +
        'legislators were sponsors. "ALL" will show only bills that all selected ' +
        "legislators were sponsors.",
    regions: regionsWithSponsors,
})

export const BillCosponsorFilter = createSelectToggleMultiFilter({
    uniqueFilterId: "billCosponsor",
    displayLabel: "Cosponsors",
    getSearchifyFLV: () => LegislatorSearchifyWithoutCampaignFinanceFLV,
    dataTypeLabel: "Members",
    filterKeyMapping: { true: "cosponsored_by_or", false: "cosponsored_by_and" },
    selectComponent: LegislatorSelectWithoutCampaignFinance,
    helpText:
        "Select individual legislators or lists of legislators to show the bills that " +
        'they have cosponsored. Selecting "ANY" will show bills where any of the selected ' +
        'legislators were cosponsors. "ALL" will show only bills that all selected ' +
        "legislators were cosponsors.",
    regions: federalAndStates,
})

export const BillNotCosponsorFilter = createSelectToggleMultiFilter({
    uniqueFilterId: "billNotCosponsor",
    displayLabel: "Not Cosponsors",
    getSearchifyFLV: () => LegislatorSearchifyWithoutCampaignFinanceFLV,
    dataTypeLabel: "Members",
    filterKeyMapping: { true: "not_cosponsored_by_or", false: "not_cosponsored_by_and" },
    selectComponent: LegislatorSelectWithoutCampaignFinance,
    helpText:
        "Select individual legislators or lists of legislators to show the bills that " +
        'they have NOT sponsored. Selecting "ANY" will show bills where none of the selected ' +
        'legislators were sponsors. "ALL" will show only bills that all selected ' +
        "were not sponsors (as a group).",
    regions: federalAndStates,
})

export const BillSponsorOrCosponsorFilter = createSelectToggleMultiFilter({
    uniqueFilterId: "billSponsorOrCosponsor",
    displayLabel: "Sponsor Or Cosponsors",
    getSearchifyFLV: () => LegislatorSearchifyWithoutCampaignFinanceFLV,
    dataTypeLabel: "Members",
    filterKeyMapping: { true: "sponsored_or_cosponsored_by_or", false: "sponsored_or_cosponsored_by_and" },
    selectComponent: LegislatorSelectWithoutCampaignFinance,
    helpText:
        "Select individual legislators or lists of legislators to show the bills that " +
        'they have sponsored OR cosponsored. Selecting "ANY" will show bills where any of the selected ' +
        'legislators were sponsors or cosponsors. "ALL" will show only bills that all selected ' +
        "legislators were sponsors or cosponsors.",
    regions: federalAndStates,
})

export class BillRelatedFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "billRelatedBillFilter",
            filterKey: "related_bill",
            searchifyFLV: BillFilterableListView,
            dataTypeLabel: "Bills",
            selectComponent: BillSelect,
            maxSearchifySelections: 20000,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const BillCompanionFilter = createSelectToggleMultiFilter({
    uniqueFilterId: "billCompanionBillFilter",
    dataTypeLabel: "Bills",
    displayLabel: "Companion Bills",
    filterKeyMapping: { true: "companion_of_or", false: "companion_of_and" },
    getSearchifyFLV: () => BillFilterableListView,
    selectComponent: BillSelect,
    maxSearchifySelections: MAX_BILL_SEARCHIFY_SELECTIONS,
    helpText:
        "Select bills to show the bills that are companions " +
        'to those selected. Selecting "ANY" will show bills where any of the ' +
        ' selected bills are companions. "ALL" will show only bills that are ' +
        " companions to all selected bills.",
})

export class BillFromBulkUploadFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "billFromBulkUploadFilter",
            filterKey: "from_bulk_upload_files",
            searchifyFLV: BulkUploadFileFLV,
            searchifyPermanentFilter: {
                upload_type: DjangIO.app.custom_data.types.BulkUploadType.bill.value,
                status: DjangIO.app.custom_data.types.BulkUploadStatus.finished.value,
            },
            dataTypeLabel: "Bill Bulk Uploads",
            displayLabel: "Bulk upload files...",
            selectComponent: BulkUploadFileSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const BillSupportedRegionsFilter = (props) => {
    const FilterComponent = props.filterComponent

    return <FilterComponent {...props} />
}
BillSupportedRegionsFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    enumItems: getBillSupportedRegionOptions(),
    uniqueFilterId: "billSupportedRegionsFilter",
    filterKey: "for_supported_regions",
    selectComponent: BillSupportedRegionSelect,
    regions: usRegions,
    displayKey: "region_name",
}

export const BillGlobalRegionsFilter = (props) => {
    const FilterComponent = props.filterComponent

    return <FilterComponent {...props} />
}
BillGlobalRegionsFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    enumItems: getBillGlobalRegionOptions(),
    uniqueFilterId: "billSupportedRegionsFilter",
    filterKey: "for_supported_regions",
    selectComponent: BillSupportedRegionSelect,
}

/*************************************************************
 * INVISIBLE FILTERS (Some for graphs, some for lists)
 **************************************************************/
export class BillInvisiblePartyFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "billPartyFilter",
        filterKey: "for_parties",
        invisible: true,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const BillInvisibleSingleYearFilter = (props) => {
    const FilterComponent = props.filterComponent
    return <FilterComponent {...props} />
}
BillInvisibleSingleYearFilter.defaultProps = {
    filterComponent: textGenericFilter,
    uniqueFilterId: "billSingleYearFilter",
    filterKey: "for_year",
    invisible: true,
}

export const BillInvisibleWithoutStanceFilter = (props) => {
    const FilterComponent = props.filterComponent
    return <FilterComponent {...props} />
}
BillInvisibleWithoutStanceFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "billWithoutStanceFilter",
    filterKey: "without_stance",
    invisible: true,
}

export const BillInvisibleStatusFilter = (props) => {
    const FilterComponent = props.filterComponent
    return <FilterComponent {...props} />
}
BillInvisibleStatusFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "billInvisibleStatusFilter",
    filterKey: "by_status",
    invisible: true,
}

export const BillInvisibleRegionFilter = (props) => {
    const FilterComponent = props.filterComponent
    return <FilterComponent {...props} />
}
BillInvisibleRegionFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "billInvisibleRegionFilter",
    filterKey: "by_region",
    invisible: true,
}

export const BillInvisibleSlugSearchFilter = (props) => {
    const FilterComponent = props.filterComponent
    return <FilterComponent {...props} />
}
BillInvisibleSlugSearchFilter.defaultProps = {
    filterComponent: textGenericFilter,
    uniqueFilterId: "billSlugSearchFilter",
    filterKey: "slug_search",
    invisible: true,
}

/*************************************************************
 * Profile specific filters!
 **************************************************************/
export const BillSponsorOfficialProfileFilter = createProfileToggleFilter({
    uniqueFilterId: "billSponsorFilter",
    trueText: "Sponsored",
    falseText: "Cosponsored",
    filterKeyMapping: {
        true: "sponsored_by_or",
        false: "cosponsored_by_or",
    },
})

export const BillOrganizatonsFilter = createProfileToggleFilter({
    uniqueFilterId: "billOrganizatonsFilter",
    trueText: "Current Org + All Subsidiaries",
    falseText: "Current Org Only",
    filterKeyMapping: {
        true: "from_public_organizations",
        false: "from_public_organization",
    },
})

export const BillProjectFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={IssueManagementFilterableListView} {...props} />
}
BillProjectFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
BillProjectFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "billProjectFilter",
    filterKey: "for_project_and_subprojects",
    dataTypeLabel: "Issues",
    selectComponent: IssueManagementSelect,
}

export const BillCommitteProfileFilter = createProfileToggleFilter({
    uniqueFilterId: "billCommitteProfileFilter",
    trueText: "Committee + All Sub Committees",
    falseText: "Current Committee Only",
    filterKeyMapping: {
        true: "from_committees",
        false: "from_committee",
    },
})

export const BillSponsorTypeFilter = (props) => {
    const FilterComponent = props.filterComponent
    return <FilterComponent {...props} />
}
BillSponsorTypeFilter.defaultProps = {
    displayLabel: "Source Type",
    enumItems: DjangIO.app.bill.models.SponsorType.region_supported_items(),
    filterComponent: enumGenericFilter,
    filterKey: "from_sponsor_type",
    regions: euRegions,
    sortBy: enumValueSort,
    uniqueFilterId: "billSponsorTypeFilter",
}

export const BillSponsorEUFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={OfficialsAndStaffEUFilterableListView} {...props} />
}
BillSponsorEUFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    displayLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
BillSponsorEUFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "billSponsorEUFilter",
    filterKey: "sponsored_by_eu",
    dataTypeLabel: "Source",
    selectComponent: OfficialsAndStaffSelect,
}

export const BillTrackingDashboardFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={TrackingDashboardFilterableListView} {...props} />
}
BillTrackingDashboardFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    searchifyPermanentFilter: PropTypes.object,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
BillTrackingDashboardFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "billTrackingDashboardFilter",
    filterKey: "for_tracking_dashboards",
    dataTypeLabel: "Tracking Dashboards",
    searchifyPermanentFilter: {
        data_type: DjangIO.app.models.QuorumDataType.bill.value,
    },
    selectComponent: TrackingDashboardSelect,
}

export const BillSponsorsCountFilter = createNumericTripletMultiFilter({
    uniqueFilterId: "billSponsorsCountFilter",
    displayLabel: "Sponsors",
    filterKeyMapping: { left: "sponsors_less_than", center: "sponsors_is_exactly", right: "sponsors_greater_than" },
    regions: federalAndStates,
})

export const BillMaleCoSponsorsCountFilter = createNumericTripletMultiFilter({
    uniqueFilterId: "billMaleCoSponsorsCountFilter",
    displayLabel: "Male Co-Sponsors",
    filterKeyMapping: {
        left: "num_male_cosponsors__lt",
        center: "num_male_cosponsors",
        right: "num_male_cosponsors__gt",
    },
    regions: federalAndStates,
})

export const BillFemaleCoSponsorsCountFilter = createNumericTripletMultiFilter({
    uniqueFilterId: "billFemaleCoSponsorsCountFilter",
    displayLabel: "Female Co-Sponsors",
    filterKeyMapping: {
        left: "num_female_cosponsors__lt",
        center: "num_female_cosponsors",
        right: "num_female_cosponsors__gt",
    },
    regions: federalAndStates,
})

export const BillRepublicanCoSponsorsCountFilter = createNumericTripletMultiFilter({
    uniqueFilterId: "billRepublicanCoSponsorsCountFilter",
    displayLabel: "Republican Co-Sponsors",
    filterKeyMapping: {
        left: "num_republican_cosponsors__lt",
        center: "num_republican_cosponsors",
        right: "num_republican_cosponsors__gt",
    },
    regions: federalAndStates,
})

export const BillDemocratCoSponsorsCountFilter = createNumericTripletMultiFilter({
    uniqueFilterId: "billDemocratCoSponsorsCountFilter",
    displayLabel: "Democrat Co-Sponsors",
    filterKeyMapping: {
        left: "num_democrat_cosponsors__lt",
        center: "num_democrat_cosponsors",
        right: "num_democrat_cosponsors__gt",
    },
    regions: federalAndStates,
})

export const BillIndependentCoSponsorsCountFilter = createNumericTripletMultiFilter({
    uniqueFilterId: "billIndependentCoSponsorsCountFilter",
    displayLabel: "Independent Co-Sponsors",
    filterKeyMapping: {
        left: "num_independent_cosponsors__lt",
        center: "num_independent_cosponsors",
        right: "num_independent_cosponsors__gt",
    },
    regions: federalAndStates,
})

export class BillLanguageFilter extends Component {
    static defaultProps = {
        filterComponent: enumSingleGenericFilter,
        isProtected: true,
        isNullable: true,
        uniqueFilterId: "billLanguage",
        filterKey: "language",
        enumItems: getBillLanguageFilterOptions(),
        sortBy: enumLabelSort,
        serialize: (values) => (values?.length ? values[0].toString() : null),
        deserialize: (value) => {
            if (!value) {
                return null
            }

            return Number.isNaN(value) ? value : parseInt(value)
        },
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}
